export default __webpack_public_path__ + "static/delivery-feature_mob_kz-e2afbe66b889ddceec94257bfcc8e89f.png";